export class PageSizeList {
    static getPageSizeList(): Array<number> {
        return [10, 20, 50];
    }
}
